import tableRowRules from '../../table/row-line';

const dark = (params) => tableRowRules.dark(params);

export default dark;
